export enum ANIMATION_STATE {
  IDLE = "idle",
  ENTERING = "entering",
  PULSING = "pulsing",
}

const PULSE_DURATION_OUT = 0.8;
const PULSE_DURATION_HOLD = 0.5; // This adds the hold when small
const PULSE_DURATION_IN = 0.8;
const PULSE_DURATION_HOLD_BIG = 0;
const PULSE_CYCLES_ENTERING = 4;

// Duration for ONE full pulse cycle (SMALL -> HOLD -> BIG -> HOLD -> SMALL)
const PULSE_CYCLE_DURATION =
  PULSE_DURATION_HOLD +
  PULSE_DURATION_IN +
  PULSE_DURATION_HOLD_BIG +
  PULSE_DURATION_OUT;

const TOTAL_ENTERING_PULSE_DURATION =
  PULSE_CYCLE_DURATION * PULSE_CYCLES_ENTERING;

export const ANIMATION_CONFIG = {
  ENTER_DURATION: 0.5,
  EXIT_DURATION: 0.4,

  BASE_DELAY: 0.1,

  // -- Coin states --
  COIN_Y_START: 25,
  COIN_Y_END: 15,
  COIN_SCALE_START: 0.5,

  // -- Pulse animation values --
  PULSE_SCALE_SMALL: 0.85,
  PULSE_SCALE_BIG: 0.93,
  PULSE_X_SHIFT_IN: -1,
  PULSE_Y_SHIFT_IN: 5,
  PULSE_X_SHIFT_OUT: 4,
  PULSE_Y_SHIFT_OUT: 8,
  BONUS_TEXT_Y_SHIFT: 3,
  BONUS_TEXT_Y_SHIFT_OUT: 5,

  PULSE_DURATION_OUT,
  PULSE_DURATION_HOLD,
  PULSE_DURATION_IN,
  PULSE_DURATION_HOLD_BIG,

  PULSE_CYCLES_ENTERING,
  PULSE_CYCLE_DURATION, // For the new PULSING loop
  TOTAL_ENTERING_PULSE_DURATION,
};

export const LOOP_CONFIG = {
  INITIAL_DELAY: 500,
  RESET_DELAY: 1000,
  PULSE_HOLD_DELAY: 500,
};